import { useTranslation } from 'react-i18next';
import log from 'loglevel';
import { History } from '@mui/icons-material';
import useNavigate from '../../../hooks/useNavigate';
import { PencilAlt } from '../../../icons/pencil-alt';
// import { ActionDelete } from '../../../icons/action-delete';
import { STRING_KEYS } from '../../../language/keys';
import MenuMoreVert from '../../../components/MenuMoreVert';
import {  TABLE } from '../../../consts';
import { PERMISSIONS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';

const TAG = '[TALENTS_ACTION_COMPONENT]';
const { ACTIONS } = TABLE;
const EXTRA_ACTIONS = {
  MATCH_HISTORY: 'MATCH_HISTORY',
};
const ACTION_OPTIONS = {
  ...ACTIONS,
  ...EXTRA_ACTIONS,
};
type TalentAction = {
  talentId: string
}

export const TalentsActions = ({
  talentId,
}: TalentAction): JSX.Element | null => {
  const { t: translate } = useTranslation();
  const { goToTalentsEdit, goToTalentView, goToTalentHistoryLog } = useNavigate();
  const { hasPermissions } = useAuth();

  const prepareTalentViewOption = () => {
    if (hasPermissions([PERMISSIONS.TALENT_EDIT])) {
      return {
        type: ACTION_OPTIONS.EDIT,
        title: translate(STRING_KEYS.EDIT),
        icon: <PencilAlt />,
      };
    }

    return {
      type: ACTION_OPTIONS.VIEW,
      title: translate(STRING_KEYS.VIEW),
      icon: <PencilAlt />,
      permissions: [PERMISSIONS.TALENT_VIEW],
    };
  };

  const actionOptions = [
    {
      ...prepareTalentViewOption(),
    },
    {
      type: ACTION_OPTIONS.MATCH_HISTORY,
      title: translate(STRING_KEYS.TALENTS_ACTION_MENU_HISTORY),
      icon: <History />,
      permissions: [PERMISSIONS.TALENT_VIEW, PERMISSIONS.TALENT_HISTORY_LOG_VIEW],
    },
    // Currently Disabled
    // {
    //   type: ACTION_OPTIONS.DELETE,
    //   title: translate(STRING_KEYS.DELETE),
    //   icon: <ActionDelete />,
    // },
  ];

  const actions = actionOptions.filter((action) => {
    return !action.permissions || hasPermissions(action.permissions);
  }).map((action) => ({
    ...action,
    key: talentId,
  }));

  const handleActions = (key: string, type: string) => {
    switch (type) {
      case ACTION_OPTIONS.EDIT:
        goToTalentsEdit(key);
        break;
      case ACTION_OPTIONS.MATCH_HISTORY:
        goToTalentHistoryLog(key);
        break;
      case ACTION_OPTIONS.VIEW:
        goToTalentView(key);
        break;
      default:
        log.warn(TAG, `Cannot find any handler for type:${type}`);
    }
  };

  if (!actions || actions.length <= 0) {
    return null;
  }

  return (
    <MenuMoreVert actions={ actions } handleActions={ handleActions } />
  );
};
